@if (user?.image) {
  <img
    [attr.src]="user.image | image: 60 : 60"
    class="user-image"
    loading="lazy"
  />
}
@if (user && !user.image) {
  <span class="user-initial">{{ initial }}</span>
}
